import { render, staticRenderFns } from "./New.vue?vue&type=template&id=415b47ea&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=415b47ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415b47ea",
  null
  
)

export default component.exports